import { getEmailScopeOrEmpty } from '@modules/crm/utils/emailHelpers'

export const leads = (state) => {
  if (state && state.leads && Array.isArray(state.leads.data)) {
    return state.leads.data
  }

  return []
}
export const monthlyRoutine = (state) => {
  if (
    state &&
    state.monthlyRoutine &&
    Array.isArray(state.monthlyRoutine.data)
  ) {
    return state.monthlyRoutine.data
  }

  return []
}
export const monthlyRoutineLoading = (state) => {
  if (state && state.monthlyRoutine) {
    return Boolean(state.monthlyRoutine.loading)
  }

  return false
}
export const monthlyRoutineLastUpdate = (state) => {
  if (state && state.monthlyRoutine) {
    return state.monthlyRoutine.lastUpdate
  }

  return null
}
export const leadsLoading = (state) => {
  if (state && state.leads) {
    return Boolean(state.leads.loading)
  }

  return false
}
export const leadsLastUpdate = (state) => {
  if (state && state.leads) {
    return state.leads.lastUpdate
  }

  return null
}
export const leadsTags = (state) => {
  return state.leads.tags || []
}

export const filterLeads = (state) => {
  return state.filterLeads || {}
}

export const ligacoes = (state) => {
  if (state && state.ligacoes && Array.isArray(state.ligacoes.data)) {
    return state.ligacoes.data
  }

  return []
}
export const ligacoesLoading = (state) => {
  if (state && state.ligacoes) {
    return Boolean(state.ligacoes.loading)
  }

  return false
}
export const ligacoesLastUpdate = (state) => {
  if (state && state.ligacoes) {
    return state.ligacoes.lastUpdate
  }

  return null
}

export const filterLigacoes = (state) => {
  return state.filterLigacoes || {}
}

export const selectedFunilId = (state) => {
  return state.selectedFunilId || null
}

export const reguaCliente = (state) => {
  return state.reguaCliente.data || []
}
export const reguaClienteLoading = (state) => {
  return state.reguaCliente.loading
}
export const reguaClienteLastUpdate = (state) => {
  return state.reguaCliente.lastUpdate
}

export const reguaRelacionamento = (state) => {
  return state.reguaRelacionamento.data || []
}
export const reguaRelacionamentoLoading = (state) => {
  return state.reguaRelacionamento.loading
}
export const reguaRelacionamentoLastUpdate = (state) => {
  return state.reguaRelacionamento.lastUpdate
}

export const atividadesRegua = (state) => {
  return state.atividadesRegua.data || []
}
export const atividadesReguaLoading = (state) => {
  return state.atividadesRegua.loading
}
export const atividadesReguaLastUpdate = (state) => {
  return state.atividadesRegua.lastUpdate
}
export const historicoAtividade = (state) => {
  return state.historicoAtividade.data || []
}
export const historicoAtividadeLoading = (state) => {
  return state.historicoAtividade.loading
}
export const historicoAtividadeLastUpdate = (state) => {
  return state.historicoAtividade.lastUpdate
}

export const atividadesSugeridas = (state) => {
  return state.atividadesSugeridas.data || []
}
export const atividadesSugeridasLoading = (state) => {
  return state.atividadesSugeridas.loading
}
export const atividadesSugeridasLastUpdate = (state) => {
  return state.atividadesSugeridas.lastUpdate
}

export const empresas = (state) => {
  if (state && state.empresas && Array.isArray(state.empresas.data)) {
    return state.empresas.data
  }
  return []
}
export const empresasLoading = (state) => {
  if (state && state.empresas) {
    return Boolean(state.empresas.loading)
  }
  return false
}
export const empresasLastUpdate = (state) => {
  if (state && state.empresas) {
    return state.empresas.lastUpdate
  }
  return null
}

export const gruposFamiliares = (state) => {
  if (
    state &&
    state.gruposFamiliares &&
    Array.isArray(state.gruposFamiliares.data)
  ) {
    return state.gruposFamiliares.data
  }
  return []
}
export const gruposFamiliaresLoading = (state) => {
  if (state && state.gruposFamiliares) {
    return Boolean(state.gruposFamiliares.loading)
  }
  return false
}
export const gruposFamiliaresLastUpdate = (state) => {
  if (state && state.gruposFamiliares) {
    return state.gruposFamiliares.lastUpdate
  }
  return null
}

export const gruposFamiliaresListagem = (state) => {
  if (
    state &&
    state.gruposFamiliaresListagem &&
    Array.isArray(state.gruposFamiliaresListagem.data)
  ) {
    return state.gruposFamiliaresListagem.data
  }
  return []
}
export const gruposFamiliaresListagemLoading = (state) => {
  if (state && state.gruposFamiliaresListagem) {
    return Boolean(state.gruposFamiliaresListagem.loading)
  }
  return false
}
export const gruposFamiliaresListagemLastUpdate = (state) => {
  if (state && state.gruposFamiliaresListagem) {
    return state.gruposFamiliaresListagem.lastUpdate
  }
  return null
}

export const funil = (state) => {
  return state.funil.data || []
}
export const funilLoading = (state) => {
  return state.funil.loading
}
export const funilLastUpdate = (state) => {
  return state.funil.lastUpdate
}
export const customizeLoading = (state) => {
  return state.funil.customizeLoading
}

export const funilSteps = (state) => {
  return state.funilSteps.data || []
}
export const funilStepsLoading = (state) => {
  return state.funilSteps.loading
}
export const funilStepsLastUpdate = (state) => {
  return state.funilSteps.lastUpdate
}

export const funilStepsTasks = (state) => {
  return state.funilStepsTasks.data || []
}
export const funilStepsTasksLoading = (state) => {
  return state.funilStepsTasks.loading
}
export const funilStepsTasksLastUpdate = (state) => {
  return state.funilStepsTasks.lastUpdate
}

export const oportunidadeFunil = (state) => {
  return state.oportunidadeFunil.data || []
}
export const oportunidadeFunilLoading = (state) => {
  return state.oportunidadeFunil.loading
}
export const oportunidadeFunilLastUpdate = (state) => {
  return state.oportunidadeFunil.lastUpdate
}

export const oportunidadeFunilEtapas = (state) => {
  return state.oportunidadeFunilEtapas.data || []
}
export const oportunidadeFunilEtapasLoading = (state) => {
  return state.oportunidadeFunilEtapas.loading
}
export const oportunidadeFunilEtapasLastUpdate = (state) => {
  return state.oportunidadeFunilEtapas.lastUpdate
}

export const oportunidadeFunilAtividades = (state) => {
  return state.oportunidadeFunilAtividades.data || []
}
export const oportunidadeFunilAtividadesLoading = (state) => {
  return state.oportunidadeFunilAtividades.loading
}
export const oportunidadeFunilAtividadesLastUpdate = (state) => {
  return state.oportunidadeFunilAtividades.lastUpdate
}

export const oportunidadeFunilCompleto = (state) => {
  if (
    state &&
    state.oportunidadeFunilCompleto &&
    state.oportunidadeFunilCompleto.data
  ) {
    return state.oportunidadeFunilCompleto.data
  }
  return { funis: [] }
}
export const oportunidadeFunilCompletoLoading = (state) => {
  return state.oportunidadeFunilCompleto.loading
}
export const oportunidadeFunilCompletoLastUpdate = (state) => {
  return state.oportunidadeFunilCompleto.lastUpdate
}

export const oportunidadeMotivosPerda = (state) => {
  return state.oportunidadeMotivosPerda.data || []
}
export const oportunidadeMotivosPerdaLoading = (state) => {
  return state.oportunidadeMotivosPerda.loading
}
export const oportunidadeMotivosPerdaLastUpdate = (state) => {
  return state.oportunidadeMotivosPerda.lastUpdate
}

export const origens = (state) => {
  return state.origens.data || []
}
export const origensLoading = (state) => {
  return state.origens.loading
}
export const origensLastUpdate = (state) => {
  return state.origens.lastUpdate
}

export const clients = (state) => {
  return state.clients.data || []
}
export const clientsSummary = (state) => {
  return state.clients.summaryData || {}
}
export const clientsTags = (state) => {
  return state.clients.tags || []
}
export const clientsLoading = (state) => {
  return state.clients.loading
}
export const clientsLastUpdate = (state) => {
  return state.clients.lastUpdate
}

export const clientsTasks = (state) => {
  return state.clientsTasks.data || []
}
export const clientsTasksSummary = (state) => {
  return state.clientsTasks.summaryData || {}
}
export const clientsTasksTags = (state) => {
  return state.clientsTasks.tags || {}
}
export const clientsTasksLoading = (state) => {
  return state.clientsTasks.loading
}
export const clientsTasksLoadingNoSave = (state) => {
  return state.clientsTasks.loadingNoSave
}
export const clientsTasksLastUpdate = (state) => {
  return state.clientsTasks.lastUpdate
}

export const relationshipFilters = (state) => {
  return state.filtersRelationship.data
}
export const leadTimeline = (state) => {
  return state.leadTimeline.data || []
}
export const leadTimelineLoading = (state) => {
  return state.leadTimeline.loading
}
export const leadTimelineLastUpdate = (state) => {
  return state.leadTimeline.lastUpdate
}

export const kYC = (state) => {
  return state.kYC.data || []
}
export const kYCLoading = (state) => {
  return state.kYC.loading
}
export const kYCLastUpdate = (state) => {
  return state.kYC.lastUpdate
}
export const kYCList = (state) => {
  return state.kYCList.data || []
}
export const kYCListLoading = (state) => {
  return state.kYCList.loading
}
export const kYCListLastUpdate = (state) => {
  return state.kYCList.lastUpdate
}

export const historicoLead = (state) => {
  return state.historicoLead.data || []
}
export const historicoLeadLoading = (state) => {
  return state.historicoLead.loading
}
export const historicoLeadLastUpdate = (state) => {
  return state.historicoLead.lastUpdate
}
export const timelineClient = (state) => {
  return state.timelineClient.data || []
}
export const timelineClientLoading = (state) => {
  return state.timelineClient.loading
}
export const timelineClientLastUpdate = (state) => {
  return state.timelineClient.lastUpdate
}
export const crmIntegrationEmail = (state) => {
  return state.crmIntegrationEmail.data || []
}
export const crmIntegrationEmailLoading = (state) => {
  return state.crmIntegrationEmail.loading
}
export const crmIntegrationEmailLastUpdate = (state) => {
  return state.crmIntegrationEmail.lastUpdate
}
export const crmIntegrationProviders = (state) => {
  return state.crmIntegrationEmail.providers || []
}
export const crmIntegrationActiveProvider = (state) => {
  const providers = state.crmIntegrationEmail.providers || []
  return providers.length ? providers[0] : null
}

export const overviewIndicators = (state) => {
  return state.overviewIndicators.data || []
}
export const overviewIndicatorsLoading = (state) => {
  return state.overviewIndicators.loading
}
export const overviewIndicatorsLastUpdate = (state) => {
  return state.overviewIndicators.lastUpdate
}
export const funilStepsConfig = (state) => {
  return state.funilStepsConfig.data || []
}
export const funilStepsConfigLoading = (state) => {
  return state.funilStepsConfig.loading
}
export const funilStepsConfigLastUpdate = (state) => {
  return state.funilStepsConfig.lastUpdate
}

export const relationshipKanban = (state) => {
  return state.relationshipKanban.data || []
}
export const relationshipKanbanLoading = (state) => {
  return state.relationshipKanban.loading
}
export const relationshipKanbanLastUpdate = (state) => {
  return state.relationshipKanban.lastUpdate
}

export const opportunitiesKanban = (state) => {
  if (
    state &&
    state.opportunitiesKanban &&
    Array.isArray(state.opportunitiesKanban.data)
  ) {
    return state.opportunitiesKanban.data
  }
  return []
}
export const opportunitiesKanbanLoading = (state) => {
  if (state && state.opportunitiesKanban) {
    return Boolean(state.opportunitiesKanban.loading)
  }
  return false
}
export const opportunitiesKanbanLastUpdate = (state) => {
  if (state && state.opportunitiesKanban) {
    return state.opportunitiesKanban.lastUpdate
  }
  return null
}

export const calendar = (state) => {
  return state.calendar.data || {}
}
export const calendarLoading = (state) => {
  return state.calendar.loading
}
export const calendarLastUpdate = (state) => {
  return state.calendar.lastUpdate
}

export const filterCalendar = (state) => {
  return state.filterCalendar || {}
}

export const calendarGoogleAgenda = (state) => {
  if (state && state.calendar && state.calendar.googleAgenda) {
    return state.calendar.googleAgenda
  }
  return { autenticado: false, erro: null }
}

export const calendarMicrosoftAgenda = (state) => {
  if (state && state.calendar && state.calendar.microsoftAgenda) {
    return state.calendar.microsoftAgenda
  }
  return { autenticado: false, erro: null }
}

export const calendarExternalAgendas = (state, getters) => {
  return {
    google: getters.calendarGoogleAgenda,
    microsoft: getters.calendarMicrosoftAgenda,
  }
}

export const calendarHasAnyExternalAuth = (state, getters) => {
  const externalAgendas = getters.calendarExternalAgendas
  return Boolean(
    (externalAgendas.google && externalAgendas.google.autenticado) ||
      (externalAgendas.microsoft && externalAgendas.microsoft.autenticado)
  )
}

export const calendarLoadedMonths = (state) => {
  if (state && state.calendar) {
    return state.calendar.loadedMonths || {}
  }
  return {}
}

export const calendarLoadingMonth = (state) => {
  if (state && state.calendar) {
    return state.calendar.loadingMonth || false
  }
  return false
}

export const observacaoClient = (state) => (idClienteApp) => {
  if (!idClienteApp || !state || !state.observacoes) return null
  return state.observacoes.byClient[idClienteApp] || null
}
export const observacaoClientLoading = (state) => (idClienteApp) => {
  if (!idClienteApp || !state || !state.observacoes) return false
  return Boolean(state.observacoes.loadingByClient[idClienteApp])
}

export const clienteLeadStatus = (state) => (idClienteApp) => {
  if (!idClienteApp || !state || !state.clienteLeadStatus) return null
  return state.clienteLeadStatus.byClienteApp[idClienteApp] || null
}
export const clienteLeadStatusLoading = (state) => (idClienteApp) => {
  if (!idClienteApp || !state || !state.clienteLeadStatus) return false
  return Boolean(state.clienteLeadStatus.loadingByClienteApp[idClienteApp])
}

export const crmEmailsCliente = (state) =>
  getEmailScopeOrEmpty(state, 'cliente').data || []

export const crmEmailsGlobal = (state) =>
  getEmailScopeOrEmpty(state, 'global').data || []

export const crmEmailsClienteLoading = (state) =>
  Boolean(getEmailScopeOrEmpty(state, 'cliente').loading)

export const crmEmailsGlobalLoading = (state) =>
  Boolean(getEmailScopeOrEmpty(state, 'global').loading)

export const crmEmailsContadoresCliente = (state) =>
  getEmailScopeOrEmpty(state, 'cliente').contadores || {}

export const crmEmailsContadoresGlobal = (state) =>
  getEmailScopeOrEmpty(state, 'global').contadores || {}

export const crmEmailsPaginationCliente = (state) =>
  getEmailScopeOrEmpty(state, 'cliente').pagination || {}

export const crmEmailsPaginationGlobal = (state) =>
  getEmailScopeOrEmpty(state, 'global').pagination || {}

export const crmEmailsFolderCliente = (state) =>
  getEmailScopeOrEmpty(state, 'cliente').folder || 'todos'

export const crmEmailsClienteIdClienteApp = (state) =>
  getEmailScopeOrEmpty(state, 'cliente').idClienteApp || null

export const crmEmailsFirstAutoSyncDone = (state) =>
  Boolean(state && state.crmEmails && state.crmEmails.firstAutoSyncDone)

export const customFields = (state) => state.customFields.data || []
export const customFieldsAtivos = (state) =>
  (state.customFields.data || [])
    .filter((f) => f && f.ativo !== false)
    .slice()
    .sort((a, b) => {
      const orderA = Number.isFinite(a.display_order) ? a.display_order : 0
      const orderB = Number.isFinite(b.display_order) ? b.display_order : 0
      if (orderA !== orderB) return orderA - orderB
      return String(a.nome || '').localeCompare(String(b.nome || ''))
    })
export const customFieldsLoading = (state) => state.customFields.loading
export const customFieldsLoaded = (state) => state.customFields.loaded
export const customFieldsLastUpdate = (state) => state.customFields.lastUpdate

export const fichaSchema = (state) => state.fichaSchema.data || null
export const fichaSchemaLoading = (state) => state.fichaSchema.loading
export const fichaSchemaLoaded = (state) => state.fichaSchema.loaded

export const summaryLayout = (state) => (entityType) => {
  if (!entityType) return []
  return (state.summary.layouts && state.summary.layouts[entityType]) || []
}
export const summaryLayoutLoaded = (state) => (entityType) => {
  if (!entityType) return false
  return Boolean(
    state.summary.layoutsLoaded && state.summary.layoutsLoaded[entityType]
  )
}
export const summaryCatalog = (state) => (entityType) => {
  if (!entityType) return []
  return (state.summary.catalogs && state.summary.catalogs[entityType]) || []
}
export const summaryCatalogLoaded = (state) => (entityType) => {
  if (!entityType) return false
  return Boolean(
    state.summary.catalogsLoaded && state.summary.catalogsLoaded[entityType]
  )
}
export const summaryDataByClienteId = (state) => (idClienteApp) => {
  if (!idClienteApp) return null
  return (
    (state.summary.dataByClienteId &&
      state.summary.dataByClienteId[idClienteApp]) ||
    null
  )
}
export const summaryFieldValue =
  (state) =>
  ({ idClienteApp, fieldKey }) => {
    if (!idClienteApp || !fieldKey) return undefined
    const entry =
      state.summary.dataByClienteId &&
      state.summary.dataByClienteId[idClienteApp]
    if (!entry || !entry.data) return undefined
    return entry.data[fieldKey]
  }

export const overviewLayout = (state) => (scope) => {
  if (!scope || !state.overview) return []
  return (state.overview.layouts && state.overview.layouts[scope]) || []
}
export const overviewLayoutLoaded = (state) => (scope) => {
  if (!scope || !state.overview) return false
  return Boolean(
    state.overview.layoutsLoaded && state.overview.layoutsLoaded[scope]
  )
}
export const overviewIsDefault = (state) => (scope) => {
  if (!scope || !state.overview) return false
  return Boolean(state.overview.isDefault && state.overview.isDefault[scope])
}
export const overviewCustomizationBlocked = (state) => (scope) => {
  if (!scope || !state.overview) return false
  return Boolean(
    state.overview.customizationBlocked &&
      state.overview.customizationBlocked[scope]
  )
}
export const overviewCatalog = (state) => {
  return (state.overview && state.overview.catalog) || []
}
export const overviewCatalogLoaded = (state) => {
  return Boolean(state.overview && state.overview.catalogLoaded)
}

export const transcriptProjects = (state) => {
  if (
    state &&
    state.transcriptProjects &&
    Array.isArray(state.transcriptProjects.data)
  ) {
    return state.transcriptProjects.data
  }
  return []
}
export const transcriptProjectsLoading = (state) => {
  if (state && state.transcriptProjects) {
    return Boolean(state.transcriptProjects.loading)
  }
  return false
}
export const transcriptProjectsLastUpdate = (state) => {
  if (state && state.transcriptProjects) {
    return state.transcriptProjects.lastUpdate
  }
  return null
}

export const transcriptScores = (state) => (id) => {
  if (!id || !state || !state.transcriptScores) return []
  return state.transcriptScores.byTranscript[id] || []
}
export const transcriptScoresLoading = (state) => (id) => {
  if (!id || !state || !state.transcriptScores) return false
  return Boolean(state.transcriptScores.loadingByTranscript[id])
}
